import {
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  checkedListEmptyMsg,
  dateValidationMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import { leaveAllotmentJson } from "../../DynamicFormsJson/Transaction/leaveAllotmentJson";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../Slice/area.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import {
  getActiveLeaveStructure,
  getLeaveStructureBySalesTeam,
  getSalesTeamLeaveStructureByStockStakeHolderTypes,
  getSalesTeamWithLeaveStructure,
  setSalesTeamWithLeaveStructure,
} from "../../Slice/leaveStructure.slice";
import { getRegionUpdated } from "../../Slice/region.slice";
import {
  getSalesExecutive,
  getSalesExecutiveTypeByAreaId,
} from "../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import {
  getStockStakeHolderType,
  getStockStakeHolderTypeForList,
} from "../../Slice/stockStakeHolderType.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { getActiveLeaveYear } from "../../Slice/year.slice";
class LeaveAllotmentTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selection: [],
      salesTeamId: "",
      uncheckedBeatIdsFromSelectedList: "",
      isError: false,
      fromDate: dayjs(),
      toDate: dayjs(),
      structureFromDate: "",
      searchValue: "",
      structureToDate: "",
      allChecked: false,
      adminFlag: false,
      leaveStructureHeaderId: "",
      leaveYearMaster: "",
      dynamicMasterData: {
        leaveYearDetail: this.props.leaveYearList.leaveYear,
        areaDetail: this.props.areaList.area,
        salesExecutiveDetail: this.props.salesExecutive.salesExecutive,
        salesPersonDetail: this.props.salesTeamList?.salesExecutive,
        beatDetail: this.props.beatList.beat,
        stockHolderTypeDetail:
          this.props.stockStakeHolderType?.stockStakeHolderTypeList,
      },
      openOutletDialog: false,
      leaveStructure: "",
      salesTeamId: "",
      fieldData: { type: "0" },
      formErrors: {},
    };
  }
  componentWillReceiveProps(nextProps) {

    if (
      this.props.leaveYearList !== nextProps.leaveYearList
    ) {
      if (
        this.props.leaveYearList?.leaveYear !==
        nextProps.leaveYearList?.leaveYear
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            leaveYearDetail:
              nextProps.leaveYearList?.leaveYear,
          },
        });
      }
    }

    if (
      this.props.stockStakeHolderTypeList !== nextProps.stockStakeHolderTypeList
    ) {
      if (
        this.props.stockStakeHolderTypeList?.stockStakeHolderTypeList !==
        nextProps.stockStakeHolderTypeList?.stockStakeHolderTypeList
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockStakeHolderTypeDetail:
              nextProps.stockStakeHolderTypeList?.stockStakeHolderTypeList,
          },
        });
      }
    }
    if (this.props.leaveStructureList !== nextProps.leaveStructureList) {
      if (
        this.props.leaveStructureList?.activeleaveStructure !==
        nextProps.leaveStructureList?.activeleaveStructure
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            leaveStructureDetail:
              nextProps.leaveStructureList?.activeleaveStructure,
          },
        });
      }
    }

    if (this.props.salesTeamList !== nextProps.salesTeamList) {
      if (
        this.props.salesTeamList?.salesExecutive !==
        nextProps.salesTeamList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesPersonDetail: nextProps.salesTeamList?.salesExecutive,
          },
        });
      }
    }

    if (
      this.props.stockStakeHolderTypeList !== nextProps.stockStakeHolderTypeList
    ) {
      if (
        this.props.stockStakeHolderTypeList?.stockStakeHolderType !==
        nextProps.stockStakeHolderTypeList?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderTypeDetail:
              nextProps.stockStakeHolderTypeList?.stockStakeHolderType,
          },
        });
      }
    }

    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutive !==
        nextProps.salesExecutive?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesExecutiveDetail: nextProps.salesExecutive?.salesExecutive,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const {
      getStockStakeHolderTypeForList,
      setSalesTeamWithLeaveStructure,
      getActiveLeaveStructure,
      getAreaByUserType,
      getRegionUpdated,
      getStockStakeHolderType,
      showLoador,
      showNotification,
      getActiveLeaveYear,
    } = this.props;
    if (navigator.onLine) {
      const userTypeId = localStorage.getItem("userTypeId");
      if (userTypeId == 1 || userTypeId == 5 || userTypeId == 6) {
        this.setState({
          adminFlag: true,
        });
      }

      setSalesTeamWithLeaveStructure({ row: [] });

      showLoador({ loador: true });
      await getStockStakeHolderTypeForList().then(({ success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
      showLoador({ loador: true });
      await getActiveLeaveStructure().then(({ success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getActiveLeaveYear().then(({ response, success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
      showLoador({ loador: false });

      showLoador({ loador: false });
      if (userTypeId == 1 || userTypeId == 5 || userTypeId == 6) {
        showLoador({ loador: true });
        getRegionUpdated().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (userTypeId == 3 || userTypeId == 4) {
        showLoador({ loador: true });
        getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
        if (this.props.params.id) {
          this.setState({ leaveStructureHeaderId: this.props.params.id });
        }
      }

      showLoador({ loador: true });
      await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
        ({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getSalesExecutive,
      getAreaByTalukaPostBody,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBody({ talukaIds: talukaJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }

      if (data.stockHolderType && data.stockHolderType != "") {
        showLoador({ loador: true });
        await getSalesExecutive({
          stockStakeHolderId: data.stockHolderType,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  checkValidationOnSubmit = () => {
    const { fieldData, adminFlag } = this.state;

    let isShowLeaveYear =
      localStorage.getItem("isShowLeaveYear") !== null
        ? localStorage.getItem("isShowLeaveYear") : 0;

    let fieldMeta = [];
    if (this.props.params.id) {
      if (fieldData.type == 0) {
        fieldMeta = leaveAllotmentJson.fieldMetaForAdminAreaGetById;
      } else if (fieldData.type == 1) {
        fieldMeta = leaveAllotmentJson.fieldMetaForSalesTeamGetById;
      } else if (fieldData.type == 2) {
        fieldMeta = leaveAllotmentJson.fieldMetaForUnderSalesTeamGetById;
      } else if (this.props.params.id && !adminFlag) {
        fieldMeta = leaveAllotmentJson.fieldMetaForManager;
      } else {
        fieldMeta = leaveAllotmentJson.fieldMeta;
      }
    } else {
      if (fieldData.type == 0 && adminFlag) {
        fieldMeta = leaveAllotmentJson.fieldMetaAdminArea;
      } else if (fieldData.type == 1 && adminFlag) {
        fieldMeta = leaveAllotmentJson.fieldMetaForSalesTeam;
      } else if (fieldData.type == 2 && adminFlag) {
        fieldMeta = leaveAllotmentJson.fieldMetaForUnderSalesTeam;
      } else {
        fieldMeta = [];
      }
    }

    // Filter out "Leave Year" if isShowLeaveYear is 0
    if (isShowLeaveYear == 0) {
      fieldMeta = fieldMeta.filter(field => field.dataKey !== 'leaveYearMaster');
    }

    const mandatoryCheckErrors = mandatoryCheck({ fieldData, fieldMeta });
    this.setState({ formErrors: mandatoryCheckErrors.formErrors });

    if (!mandatoryCheckErrors.formValid) return false;

    const validationCheckErrors = ValidationCheck({ fieldData, fieldMeta });
    this.setState({ formErrors: validationCheckErrors.formErrors });

    return validationCheckErrors.formValid;
  };

  onSearchList = () => {
    const { fieldData } = this.state;
    const {
      getSalesTeamWithLeaveStructure,
      getLeaveStructureBySalesTeam,
      getSalesTeamLeaveStructureByStockStakeHolderTypes,
      showLoador,
      showNotification,
    } = this.props;

    if (navigator.onLine) {
      let leaveStructureHeaderId = this.props.params.id
        ? this.props.params.id
        : fieldData.leaveStructure;

      let salesTeamId = fieldData.salesTeamIds;
      let leaveYearMaster = fieldData.leaveYearMaster;

      this.setState({ leaveYearMaster, leaveStructureHeaderId, salesTeamId });

      let dataObj = {
        stockStakeHolderTypeId: fieldData.stockStakeHolderType,
        areaIds:
          typeof fieldData.area == "string"
            ? fieldData.area.split(",")
            : fieldData.area,
        leaveStructureHeaderId: leaveStructureHeaderId,
      };

      let dataJsonNew = {
        leaveStructureHeaderId: leaveStructureHeaderId,
        salesTeamId: fieldData.salesTeamIds,
        stockStakeHolderTypeIds:
          typeof fieldData.salesTeamTypeId == "string"
            ? fieldData.salesTeamTypeId.split(",")
            : fieldData.salesTeamTypeId,
      };

      if (this.checkValidationOnSubmit()) {
        if (fieldData.type == 0) {
          showLoador({ loador: true });
          getSalesTeamWithLeaveStructure({ dataJson: dataObj }).then(
            ({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        } else if (fieldData.type == 1) {
          showLoador({ loador: true });
          getLeaveStructureBySalesTeam({
            leaveStructureHeaderId: leaveStructureHeaderId,
            salesTeamId: salesTeamId,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        } else {
          showLoador({ loador: true });
          getSalesTeamLeaveStructureByStockStakeHolderTypes({
            dataJson: dataJsonNew,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSubmit = () => {
    const { leaveStructureList, showLoador, showNotification } = this.props;
    const { leaveStructureHeaderId, fromDate, toDate, leaveYearMaster } = this.state;

    let saveList = [];

    let validFromDate = "";
    let validToDate = "";
    let isShowLeaveYear =
      localStorage.getItem("isShowLeaveYear") !== null
        ? localStorage.getItem("isShowLeaveYear") : 0;

    leaveStructureList.leaveStructureAllotment.map((obj) => {
      if (obj.isChecked) {
        validFromDate = new Date(obj.fromDate);
        validToDate = new Date(obj.toDate);

        if (obj.leaveStructureAllotmentId !== "") {
          saveList.push({
            id: obj.leaveStructureAllotmentId,
            salesTeam: { id: obj.id },
            leaveYearMaster: isShowLeaveYear == 1 ? { id: leaveYearMaster } : null,
            leaveStructureHeader: { id: leaveStructureHeaderId },
            fromDate: obj.fromDate
              ? dayjs(obj.fromDate).format("DD-MM-YYYY")
              : dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: obj.toDate
              ? dayjs(obj.toDate).format("DD-MM-YYYY")
              : dayjs(toDate).format("DD-MM-YYYY"),
          });
        } else {
          saveList.push({
            salesTeam: { id: obj.id },
            leaveStructureHeader: { id: leaveStructureHeaderId },
            leaveYearMaster: isShowLeaveYear == 1 ? { id: leaveYearMaster } : null,
            fromDate: obj.fromDate
              ? dayjs(obj.fromDate).format("DD-MM-YYYY")
              : dayjs(fromDate).format("DD-MM-YYYY"),
            toDate: obj.toDate
              ? dayjs(obj.toDate).format("DD-MM-YYYY")
              : dayjs(toDate).format("DD-MM-YYYY"),
          });
        }
      }
      console.log(saveList);
    });

    if (saveList.length !== 0) {
      if (validFromDate > validToDate) {
        showNotification({ msg: dateValidationMsg, severity: "error" });
      } else {
        swal({
          title: "Are you sure?",
          text: saveWarningMsg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            showLoador({ loador: true });
            apiPost({
              url: endpoint.leaveStructureAllotment + "/save-list",
              postBody: saveList,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (success) {
                if (
                  data &&
                  data.data &&
                  data.data.message &&
                  data.data.leaveStructureAllotments &&
                  data.data.leaveStructureAllotments.length !== 0
                ) {
                  showNotification({
                    msg: data.data.message,
                    severity: "error",
                  });
                } else {
                  showNotification({ msg: savemsg });
                  if (this.props.params.id) {
                    this.props.navigate("/leave-structure");
                  } else {
                    window.location.reload();
                  }
                }
              } else {
                showNotification({ msg: saveFailedMsg, severity: "error" });
              }
              return success;
            });
          }
        });
      }
    } else {
      showNotification({ msg: checkedListEmptyMsg, severity: "error" });
    }
  };

  handleClick = (e, id) => {
    const { leaveStructureList, setSalesTeamWithLeaveStructure } = this.props;

    this.setState({ selection: e });

    let data = leaveStructureList.leaveStructureAllotment.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          isChecked: e.target.checked,
        };
      } else {
        return dataObj;
      }
    });
    setSalesTeamWithLeaveStructure({ row: data });
  };

  handleAllCheckedClick = (e) => {
    const { leaveStructureList, setSalesTeamWithLeaveStructure } = this.props;

    this.setState({ allChecked: e.target.checked });

    let data = leaveStructureList.leaveStructureAllotment.map((dataObj) => {
      return {
        ...dataObj,
        isChecked: e.target.checked,
      };
    });
    setSalesTeamWithLeaveStructure({ row: data });
  };

  onDateChange = (row, name) => (date) => {
    const { leaveStructureList, setSalesTeamWithLeaveStructure } = this.props;
    let updatedAllotment = leaveStructureList.leaveStructureAllotment.map(
      (dataObj) => {
        if (dataObj.id === row.id) {
          return {
            ...dataObj,
            [name]: date,
            ...(name === "fromDate" && { fromDateFlag: true }),
          };
        } else {
          return dataObj;
        }
      }
    );
    setSalesTeamWithLeaveStructure({ row: updatedAllotment });
  };

  onDateChangeAll = (e, name) => {
    const { leaveStructureList, setSalesTeamWithLeaveStructure } = this.props;

    if (name === "fromDate") {
      this.setState({ structureFromDate: e });
    } else {
      this.setState({ structureToDate: e });
    }

    let list = leaveStructureList?.leaveStructureAllotment.map((rowData) => {
      return {
        ...rowData,
        [name]: e,
      };
    });
    setSalesTeamWithLeaveStructure({ row: list });
  };

  onSearchBox = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["areaNames"] &&
          currentRow["areaNames"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["stockStakeHolderTypeName"] &&
          currentRow["stockStakeHolderTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData, dynamicMasterData, adminFlag } = this.state;
    const { setSalesTeamWithLeaveStructure } = this.props;

    const fieldMeta = this.props.params.id
      ? fieldData.type == 0
        ? leaveAllotmentJson.fieldMetaForAdminAreaGetById
        : fieldData.type == 1
          ? leaveAllotmentJson.fieldMetaForSalesTeamGetById
          : fieldData.type == 2
            ? leaveAllotmentJson.fieldMetaForUnderSalesTeamGetById
            : this.props.params.id && !adminFlag
              ? leaveAllotmentJson.fieldMetaForManager
              : leaveAllotmentJson.fieldMeta
      : fieldData.type == 0 && adminFlag
        ? leaveAllotmentJson.fieldMetaAdminArea
        : fieldData.type == 1 && adminFlag
          ? leaveAllotmentJson.fieldMetaForSalesTeam
          : fieldData.type == 2 && adminFlag
            ? leaveAllotmentJson.fieldMetaForUnderSalesTeam
            : [];

    const dataToSearch = {};
    let dataToReset = { ...this.state.fieldData };

    if (fieldName === "type") {
      dataToReset = { type: newValue };
      this.setState(
        {
          fieldData: dataToReset,
          dynamicMasterData: {
            ...dynamicMasterData,

            regionDetail: [],
            stateDetail: [],
            zoneDetail: [],
            districtDetail: [],
            talukaDetail: [],
            areaDetail: [],
            salesExecutiveDetail: [],
            typeDetail: [],
          },
        },
        () => {
          if (newValue == 0 && adminFlag) {
            this.props.getRegionUpdated();
          } else if (newValue == 0 || newValue == 1 || newValue == 2) {
            this.props.getStockStakeHolderType({ userTypeIds: "3,4" });
          }
          this.props.setSalesTeamWithLeaveStructure({ row: [] });
        }
      );
      return;
    }

    (fieldMeta || []).map((currentField) => {
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");

        masterKeyList.forEach((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
        });

        this.getListById(dataToSearch);
      }

      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.forEach((key) => {
          if (key == fieldName && dataToReset[currentField.dataKey]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }

      return null;
    });

    if (fieldName === "stockHolderType") {
      const allTypes = dynamicMasterData.stockHolderTypeDetail || [];
      const selectedType = allTypes.find((item) => item.id === newValue);

      let filteredTypes = [];
      if (selectedType) {
        if (selectedType.userType.id === 3) {
          filteredTypes = allTypes.filter(
            (item) =>
              item.userType.id === 3 && item.sortOrder > selectedType.sortOrder
          );
          const dsr = allTypes.find((item) => item.userType.id === 4);
          if (dsr) filteredTypes.push(dsr);
        } else if (selectedType.userType.id === 4) {
          filteredTypes = [];
        }
      }

      this.setState({
        dynamicMasterData: {
          ...dynamicMasterData,
          typeDetail: filteredTypes,
        },
        fieldData: {
          ...dataToReset,
          salesTeamTypeId: "",
        },
      });
    }

    dataToReset[fieldName] = newValue;

    // When leaveYearMaster is selected and isShowLeaveYear == 1,
    // auto-populate structureFromDate and structureToDate from activeleaveStructure
    if (fieldName === "leaveYearMaster") {
      const isShowLeaveYear =
        localStorage.getItem("isShowLeaveYear") !== null
          ? localStorage.getItem("isShowLeaveYear")
          : 0;

      if (isShowLeaveYear == 1) {
        const leaveYearDetails =
          this.props.leaveYearList?.leaveYear || [];

        const selectedYear = leaveYearDetails.find(
          (item) => item.id == newValue
        );

        if (selectedYear) {
          const newFromDate = selectedYear.fromDate
            ? dayjs(selectedYear.fromDate, ["DD-MM-YYYY", "YYYY-MM-DD"])
            : null;

          const newToDate = selectedYear.toDate
            ? dayjs(selectedYear.toDate, ["DD-MM-YYYY", "YYYY-MM-DD"])
            : null;

          this.setState({
            fieldData: dataToReset,
            structureFromDate: newFromDate,
            structureToDate: newToDate,
          });
          return;
        }
      }
    }

    this.setState({
      fieldData: dataToReset,
    });
  };
  render() {
    const { leaveStructureList } = this.props;
    const {
      dynamicMasterData,
      toDate,
      fromDate,
      adminFlag,
      structureFromDate,
      structureToDate,
      allChecked,
      leaveStructureHeaderId,
      fieldData,
      formErrors,
    } = this.state;

    let selectedFieldMeta;
    let isShowLeaveYear = localStorage.getItem("isShowLeaveYear") !== null ? localStorage.getItem("isShowLeaveYear") : 0;

    if (this.props.params.id && adminFlag) {
      if (fieldData.type == 0) {
        selectedFieldMeta = leaveAllotmentJson.fieldMetaForAdminAreaGetById;
      } else if (fieldData.type == 1) {
        selectedFieldMeta = leaveAllotmentJson.fieldMetaForSalesTeamGetById;
      } else if (fieldData.type == 2) {
        selectedFieldMeta = leaveAllotmentJson.fieldMetaForUnderSalesTeamGetById;
      }
    } else if (this.props.params.id && !adminFlag) {
      selectedFieldMeta = leaveAllotmentJson.fieldMetaForManager;
    } else if (fieldData.type == 0 && adminFlag) {
      selectedFieldMeta = leaveAllotmentJson.fieldMetaAdminArea;
    } else if (fieldData.type == 1 && adminFlag) {
      selectedFieldMeta = leaveAllotmentJson.fieldMetaForSalesTeam;
    } else if (fieldData.type == 2 && adminFlag) {
      selectedFieldMeta = leaveAllotmentJson.fieldMetaForUnderSalesTeam;
    } else {
      selectedFieldMeta = [];
    }

    // Filter out "Leave Year" if isShowLeaveYear is 0
    const finalFieldMeta = isShowLeaveYear == 0
      ? selectedFieldMeta.filter(field => field.dataKey !== 'leaveYearMaster')
      : selectedFieldMeta;
    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutValidation
            dynamicMasterData={dynamicMasterData}
            screenTitle={leaveAllotmentJson.screenTitle}
            fieldMeta={finalFieldMeta}
            apiBaseURL={leaveAllotmentJson.apiBaseURL}
            formErrors={formErrors}
            showSaveBtn={true}
            saveBtnText={"Search"}
            showSaveNextBtn={false}
            showSaveBtnMain={false}
            onFormSave={this.onSearchList}
            // getDataById={this.getDataById}
            getListById={this.getListById}
            getByIdApi={true}
            callApi={true}
            fieldData={fieldData}
            onDataChange={this.onDataChange}
            showBackToList={this.props.params.id ? true : false}
          />

          <br />

          {leaveStructureList?.leaveStructureAllotment?.length !== 0 && (
            <>
              <LandingScreenHeader
                screenTitle={""}
                showSearchBox={true}
                showTable={true}
                showFilter={false}
                showPdfDownload={false}
                showExcelDownload={false}
                onSearch={this.onSearchBox}
              />
              <TableContainer style={{ maxHeight: "550px", overflow: "auto" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="error"
                          onClick={(event) => this.handleAllCheckedClick(event)}
                          checked={allChecked}
                          disabled={false}
                          inputProps={{
                            "aria-label": "select all desserts",
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">Sr. No.</TableCell>
                      <TableCell align="center">Employee Code</TableCell>
                      <TableCell align="center">Name</TableCell>

                      {(fieldData.type == 1 || fieldData.type == 2) && (
                        <TableCell align="center">Type</TableCell>
                      )}

                      <TableCell align="center">Area</TableCell>
                      <TableCell align="center" width="20%">
                        <div>From Date</div>
                        <div>
                          <div>
                            <BasicDatePicker
                              color="primary"
                              name="fromDate"
                              size="small"
                              value={structureFromDate}
                              minDate={
                                isShowLeaveYear == 1 && structureFromDate
                                  ? structureFromDate
                                  : dayjs()
                              }
                              maxDate={
                                isShowLeaveYear == 1 && structureToDate
                                  ? structureToDate
                                  : undefined
                              }
                              disabled={false}
                              onChange={(e) => {
                                this.onDateChangeAll(e, "fromDate");
                              }}
                            />
                          </div>
                        </div>
                      </TableCell>
                      <TableCell align="center" width="20%">
                        <div>To Date</div>
                        <div>
                          <div>
                            <BasicDatePicker
                              color="primary"
                              name="toDate"
                              size="small"
                              value={structureToDate}
                              minDate={
                                isShowLeaveYear == 1 && structureFromDate
                                  ? structureFromDate
                                  : structureFromDate
                              }
                              maxDate={
                                isShowLeaveYear == 1 && structureToDate
                                  ? structureToDate
                                  : undefined
                              }
                              disabled={false}
                              onChange={(e) => {
                                this.onDateChangeAll(e, "toDate");
                              }}
                            />
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.getFilteredTableData(
                      leaveStructureList?.leaveStructureAllotment
                    )?.map((row, index) => (
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            onClick={(event) => this.handleClick(event, row.id)}
                            checked={row.isChecked}
                            disabled={false}
                            inputProps={{
                              "aria-labelledby": `enhanced-table-checkbox-${index}`,
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          {row?.employeeCode || "-"}
                        </TableCell>
                        <TableCell align="left">{row.name}</TableCell>
                        {(fieldData.type == 1 || fieldData.type == 2) && (
                          <TableCell align="left">
                            {row.stockStakeHolderTypeName}
                          </TableCell>
                        )}
                        <TableCell align="left">{row.areaNames}</TableCell>
                        <TableCell>
                          {row.fromDate ? (
                            <BasicDatePicker
                              color="primary"
                              name="fromDate"
                              size="small"
                              value={row.fromDate}
                              minDate={
                                isShowLeaveYear == 1 && structureFromDate
                                  ? structureFromDate
                                  : dayjs()
                              }
                              maxDate={
                                isShowLeaveYear == 1 && structureToDate
                                  ? structureToDate
                                  : undefined
                              }
                              // disabled={row.fromDateFlag ? false : true}
                              disabled={false}
                              onChange={this.onDateChange(row, "fromDate")}
                            />
                          ) : (
                            <BasicDatePicker
                              color="primary"
                              name="fromDate"
                              size="small"
                              value={structureFromDate}
                              disabled={false}
                              minDate={
                                isShowLeaveYear == 1 && structureFromDate
                                  ? structureFromDate
                                  : dayjs()
                              }
                              maxDate={
                                isShowLeaveYear == 1 && structureToDate
                                  ? structureToDate
                                  : undefined
                              }
                              onChange={this.onDateChange(row, "fromDate")}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <BasicDatePicker
                            color="primary"
                            name="toDate"
                            size="small"
                            value={row.toDate ? row.toDate : structureToDate}
                            disabled={false}
                            minDate={
                              isShowLeaveYear == 1 && structureFromDate
                                ? structureFromDate
                                : row.fromDate
                                  ? row.fromDate
                                  : fromDate
                            }
                            maxDate={
                              isShowLeaveYear == 1 && structureToDate
                                ? structureToDate
                                : undefined
                            }
                            onChange={this.onDateChange(row, "toDate")}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <>
                <br />
                <Grid
                  item
                  sm={12}
                  xs={12}
                  md={12}
                  lg={12}
                  rowSpacing={2}
                  columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                  container
                  justifyContent="right"
                >
                  <ButtonCompo
                    size="medium"
                    type="submit"
                    variant="contained"
                    name="Submit"
                    onClick={this.onSubmit}
                  />
                </Grid>
              </>
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stockStakeHolderTypeList: state.stockStakeHolderType,
  leaveStructureList: state.leaveStructure,
  managerList: state.manager,
  areaList: state.area,
  salesExecutive: state.salesExecutive,
  salesTeamList: state.salesExecutive,
  beatList: state.beat,
  outletList: state.outlet,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  leaveYearList: state.year,
});
const mapDispatchToProps = {
  getAreaByUserType,
  getRegionUpdated,
  getSalesExecutiveTypeByAreaId,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBody,
  getStateByRegion,
  showLoador,
  showNotification,
  getStockStakeHolderTypeForList,
  getActiveLeaveStructure,
  getSalesTeamWithLeaveStructure,
  setSalesTeamWithLeaveStructure,
  getStockStakeHolderType,
  getSalesExecutive,
  getLeaveStructureBySalesTeam,
  getSalesTeamLeaveStructureByStockStakeHolderTypes,
  getActiveLeaveYear,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LeaveAllotmentTable);